import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';

import {booleanConvert, stableSort, getSorting} from '../Common/helpers';
import EnhancedTableHead from '../Common/TableHead/EnhancedTableHead';
import ModalBox from '../Common/Modals/ModalBox';
import Search from '../Common/Search/Search';

import './style.css';

import { API } from '../../ws/constants';

class Clients extends Component {
    state = {
        fetchData:null
        ,openModal:false
        ,order:'asc'
        ,orderBy:'FirstName'
        ,page:0
        ,rowsPerPage:10
        ,tableLoading:false
    };
    
    componentDidMount() {
        this.setState({tableLoading:true});
        fetch(API + "getclients")
        .then(response => response.json())
        .then(data => this.setState({ fetchData: data, tableLoading:false }));
    }

    deleteRow = (clientId) => {
        if(window.confirm("Tem a certeza que quer apagar este cliente?")){
            this.setState({tableLoading:true});
            fetch(API + 'deleteclient&clientid=' + clientId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, tableLoading:false });
                $(findDOMNode(this.refs["clientId_" + clientId])).remove();
            });
        }
    }

    openModal = (textObj) => {
        this.setState({ returnTitle: textObj.title, returnText: textObj.text , openModal: true });
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
    }

    handleSearch = (search) => {
        this.setState({ tableLoading:true, page: 0 });
        fetch(API + "searchclients&keyword="+search)
        .then(response => response.json())
        .then(data => this.setState({ fetchData: data, tableLoading:false }));
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    render() {
        const { isAdmin, loginData } = this.props;
        const clients = this.state.fetchData!=null ? this.state.fetchData.data : []
              , loadingClass = this.state.tableLoading ? " ajaxLoading" : ""
              , { order, orderBy, rowsPerPage, page } = this.state
              , headerRows = [
                  { id: 'ClientId', active: true, numeric: false, className: 'midHeader', label: 'Id Int' },
                  { id: 'FirstName', numeric: false, label: 'Nome' },
                  { id: 'Gender', numeric: false, className: 'smallerHeader', label: 'Sexo' },
                  { id: 'CellPhone', numeric: false, label: 'Telemóvel' },
                  { id: 'Email', numeric: false, label: 'Email' },
                  { id: 'IsActive', numeric: false, className: 'smallerHeader', label: 'Ativo' },
                  { id: 'actions', notSortable: true, label: 'Ações' },
              ];
        return (
            <div id="clientPage">
                <div>
                    <div className="row">
                        <Search searchCallback={this.handleSearch}
                                className="col-12 col-md-4"/>
                    </div>
                    <div className="pageHeader">
                        <h1>
                            <i className="fa fa-address-book"></i> Clientes <span className="arrayCount">({clients.length})</span>
                            { (isAdmin || loginData.profile.Clients.ADD) && 
                                <span className="float-right">
                                    <Tooltip
                                        title={"Adicionar Cliente"}
                                        enterDelay={200}>
                                        <span><NavLink className="actionButton success" to={"/Clients/New"}><i className="fa fa-plus"></i></NavLink></span>
                                    </Tooltip>
                                </span>
                            }
                        </h1>
                    </div>
                    <Table className={"responsiveTable customTable" + loadingClass}>
                        <EnhancedTableHead
                            className="tableRow tableHeader"
                            headerRows={headerRows}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                            rowCount={clients.length}>
                        </EnhancedTableHead>
                        <TableBody>
                            {stableSort(clients, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(client =>
                            <TableRow key={client.Id} className="tableRow" ref={"clientId_" + client.Id}>
                                <TableCell data-title="Id Int" className="tableCell midCell">{client.ClientId}</TableCell >
                                <TableCell data-title="Nome" className="tableCell">
                                    <Tooltip
                                        title={client.FullName}
                                        enterDelay={200}>
                                        <span><NavLink to={"/Clients/"+client.Id}>{client.FirstName} {client.LastName}</NavLink></span>
                                    </Tooltip>
                                    {
                                        client.GlobalNotes && (isAdmin || loginData.profile.Clients.globalNotes) &&
                                        <Tooltip
                                            title={client.GlobalNotes}
                                            enterDelay={200}>
                                            <span><button className="simpleBtn danger globalNotesWarning" onClick={() => this.openModal({ title: "Notas do Cliente", text: client.GlobalNotes })}><i className="far fa-sticky-note fa-2x"></i></button></span>
                                        </Tooltip>
                                    }
                                </TableCell>
                                <TableCell data-title="Sexo" className="tableCell smallerCell">{client.Gender}</TableCell>
                                <TableCell data-title="Telemóvel" className="tableCell">{client.CellPhone}</TableCell>
                                <TableCell data-title="Email" className="tableCell">{client.Email}</TableCell>
                                <TableCell data-title="Ativo" className="tableCell smallerCell">{booleanConvert(client.IsActive)}</TableCell>
                                <TableCell data-title="Ações" className="tableCell actions" data-row-id={client.Id}>
                                    {(isAdmin || loginData.profile.Clients.permission === 1) &&
                                        <Tooltip
                                            title={"Editar Cliente"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton warning" to={"/Clients/"+client.Id}><i className="fa fa-pencil-alt"></i></NavLink></span>
                                        </Tooltip>
                                    }
                                    {loginData.profile.Clients && loginData.profile.Clients.permission === 2 &&
                                        <Tooltip
                                            title={"Ver Cliente"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton success" to={"/Clients/"+client.Id}><i className="fa fa-eye"></i></NavLink></span>
                                        </Tooltip>
                                    }
                                    {(isAdmin || loginData.profile.Clients.DEL) &&
                                        <Tooltip
                                            title={"Eliminar Cliente"}
                                            enterDelay={200}>
                                            <span><button type="button" className="simpleBtn actionButton danger" onClick={() => this.deleteRow(client.Id)}><i className="fa fa-times"></i></button></span>
                                        </Tooltip>
                                    }
                                </TableCell>
                            </TableRow>
                            )}
                        </TableBody>
                    </Table>
				</div>
                <div className="row">
                    <div className="col-12">
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={clients.length}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage="Linhas por página:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            page={page}
                            backIconButtonProps={{
                                'aria-label': 'Página anterior',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Próxima página',
                            }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default Clients;
